import { useState } from "react";
import styles from "./botones.module.css";



function variantDefault(props) {
	if (props.hasOwnProperty("variant")) {
		return props.variant;
	} 
	return 0; 
}
function buttonDefault(props) {
	if (props.hasOwnProperty("button")) {
		return props.button;
	} else if (props.hasOwnProperty("defaultTexts") && props.defaultTexts === "on") {
		return "Button"; 
	}
	return " ";
}

export default function Botones(props) {
	let id = "";
	let defaultTexts = "off";
	let defaultImages = "off";
	if (props.id) {
		id = props.id;
	}
	if (props.defaultTexts) {
		defaultTexts = props.defaultTexts;
	}
	if (props.defaultImages) {
		defaultImages = props.defaultImages;
	}

	const [variant, setvariant] = useState(() => variantDefault(props));
	const [wcfHighlight, setwcfHighlight] = useState("off");					// for app-demo highlight

	const [button, setbutton] = useState(() => buttonDefault(props));

	document.addEventListener("wcfSubcompsService", (e) => {
		if (e.detail.id && e.detail.id === id) {
			if (e.detail.hasOwnProperty("variant")) {
				setvariant(e.detail.variant);
			}
			if (e.detail.hasOwnProperty("wcfHighlight")) {
				setwcfHighlight(e.detail.wcfHighlight);
			}
			if (e.detail.hasOwnProperty("button")) {
				setbutton(e.detail.button);
			}
		}
	});

	let wcfHighlightClass;
	if (wcfHighlight == "on") {
		wcfHighlightClass = styles["wcfHighlightClass"];
	} else {
		wcfHighlightClass = "";
	}	

	let botones1Diff1 = "";
	let buttonDiff1 = "";

	if (variant == 1) {
		botones1Diff1 = styles["botones_1-diff1"];
		buttonDiff1 = styles["button-diff1"];
	}

	return (
		<div
		   id="68:57"
		   dataName="botones"
		   dataComponentId="botones"
		   dataStringAttr="Property_1-secondary"
		   dataIsVariantDefault="true"
		   className={styles["css-botones-3"]+" "+styles["botones"]+" "+wcfHighlightClass+" "+`${botones1Diff1}`}
		   dataWcfid="botones">
			<p
			   id="68:58"
			   dataName="button"
			   className={styles["css-Button-3"]+" "+styles["button"]+" "+`${buttonDiff1}`}
			   dataWcfid="button">
				{button}
			</p>
		</div>
	)

}
